__turbopack_context__.v({
  "blackOverlay": "krails-hero-module__I1YpAa__blackOverlay",
  "brandLtr": "krails-hero-module__I1YpAa__brandLtr",
  "contentWrapper": "krails-hero-module__I1YpAa__contentWrapper",
  "ctaButton": "krails-hero-module__I1YpAa__ctaButton",
  "description": "krails-hero-module__I1YpAa__description",
  "gradientOverlay": "krails-hero-module__I1YpAa__gradientOverlay",
  "heading": "krails-hero-module__I1YpAa__heading",
  "heroLogoImg": "krails-hero-module__I1YpAa__heroLogoImg",
  "heroLogoWrap": "krails-hero-module__I1YpAa__heroLogoWrap",
  "heroSection": "krails-hero-module__I1YpAa__heroSection",
  "heroTextContainer": "krails-hero-module__I1YpAa__heroTextContainer",
  "imageContainer": "krails-hero-module__I1YpAa__imageContainer",
  "interfaceImage": "krails-hero-module__I1YpAa__interfaceImage",
  "logoLine": "krails-hero-module__I1YpAa__logoLine",
  "logoWrap": "krails-hero-module__I1YpAa__logoWrap",
  "mark": "krails-hero-module__I1YpAa__mark",
  "perspectiveWrapper": "krails-hero-module__I1YpAa__perspectiveWrapper",
  "placeholder": "krails-hero-module__I1YpAa__placeholder",
  "placeholderBody": "krails-hero-module__I1YpAa__placeholderBody",
  "placeholderCard": "krails-hero-module__I1YpAa__placeholderCard",
  "placeholderContent": "krails-hero-module__I1YpAa__placeholderContent",
  "placeholderHeader": "krails-hero-module__I1YpAa__placeholderHeader",
  "placeholderItem": "krails-hero-module__I1YpAa__placeholderItem",
  "placeholderMain": "krails-hero-module__I1YpAa__placeholderMain",
  "placeholderSidebar": "krails-hero-module__I1YpAa__placeholderSidebar",
  "prefix": "krails-hero-module__I1YpAa__prefix",
  "prefixLine": "krails-hero-module__I1YpAa__prefixLine",
  "srOnly": "krails-hero-module__I1YpAa__srOnly",
  "subheading": "krails-hero-module__I1YpAa__subheading",
  "textContent": "krails-hero-module__I1YpAa__textContent",
  "transformedContainer": "krails-hero-module__I1YpAa__transformedContainer",
  "transformedContent": "krails-hero-module__I1YpAa__transformedContent",
});
